export default __webpack_public_path__ + "static/media/RealCase.mobile.f07f5b47.jpg";